import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';

import { delayFunctionCall } from 'helpers/delay';

import { useTabChangeContext } from '../../hooks/useTabChangeContext';
import { IPlannedExpenseValuesType, useGetPlannedExpenseOptions } from '../utils/form';

export const useFocusForm = () => {
  const { onTabChange } = useTabChangeContext();

  const { setFocus } = useFormContext();
  const PLANNED_EXPENSE_OPTIONS = useGetPlannedExpenseOptions();

  const focusForm = useCallback((expenseOptionName: IPlannedExpenseValuesType, fieldName: string) => {
    const expenseOption = PLANNED_EXPENSE_OPTIONS.find((option) => option.value === expenseOptionName);

    onTabChange([expenseOption!]);
    // delayed purposely to focus on a text input element in a different form
    delayFunctionCall(() => setFocus(fieldName));
  }, []);

  return focusForm;
};
